import React, { useEffect, useState } from 'react';
import { BellIcon, MessageCircleIcon } from 'lucide-react';
import { useJobMessaging } from './JobMessagingContext';
import { JobMessageModal } from './JobMessageModal';
interface JobMessagingNotificationProps {
  jobId?: string;
}
export const JobMessagingNotification: React.FC<JobMessagingNotificationProps> = ({
  jobId
}) => {
  const {
    getUnreadMessageCount,
    setActiveConversationJobId
  } = useJobMessaging();
  const [unreadCount, setUnreadCount] = useState(0);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [jobName, setJobName] = useState('');
  // Sample job data for mapping job IDs to names
  const MOCK_JOB_NAMES: Record<string, string> = {
    'job-1': 'Downtown Commercial Complex Phase 1',
    'job-2': 'Highway 89 Expansion Project',
    'job-3': 'Residential Development Phase 2',
    'contractor-job-1': 'Downtown Commercial Complex Phase 1',
    'direct-job-1': 'City Center Renovation'
  };
  // Update unread count every second
  useEffect(() => {
    const interval = setInterval(() => {
      setUnreadCount(jobId ? getUnreadMessageCount(jobId) : getUnreadMessageCount());
    }, 1000);
    return () => clearInterval(interval);
  }, [jobId, getUnreadMessageCount]);
  // Set job name when job ID changes
  useEffect(() => {
    if (jobId) {
      setJobName(MOCK_JOB_NAMES[jobId] || 'Job');
    }
  }, [jobId]);
  const handleOpenMessages = () => {
    if (jobId) {
      setShowMessageModal(true);
      setActiveConversationJobId(jobId);
    }
  };
  return <>
      
      {showMessageModal && jobId && <JobMessageModal jobId={jobId} jobName={jobName} onClose={() => setShowMessageModal(false)} data-id="element-297" />}
    </>;
};